import { useQuery } from '@tanstack/react-query'
import { api } from '../api/client'

/**
 * Shared subscription snapshot for the current user. Used by TopBar to show
 * the Premium badge and by profile to show period-end. Re-uses a single
 * query key so all consumers stay in sync — no duplicate fetches.
 *
 * `fastPolling` flips the refetch cadence to 3 seconds — set by the paywall
 * after the user hits "Subscribe" so Premium reflects within seconds of TG
 * sending us `successful_payment` instead of waiting up to 5 minutes.
 */
export function useEntitlements({ fastPolling = false }: { fastPolling?: boolean } = {}) {
  return useQuery({
    queryKey: ['entitlements', 'me'],
    queryFn: () => api.entitlementsMe(),
    staleTime: fastPolling ? 0 : 60_000,
    refetchInterval: fastPolling ? 3_000 : 5 * 60_000,
  })
}
